import { assertInInjectionContext, inject } from "@angular/core";
import { BalanceQuery } from "./balance.query";
import { MemberQuery } from "../member/member.query";

export function getLoyaltyBalance(): number{
    assertInInjectionContext(getLoyaltyBalance);
    const virtualLoyalty = 6;
    const memberId = inject(MemberQuery).getUserContext().memberId;
    return inject(BalanceQuery).getEntity([memberId, virtualLoyalty].join('-'))?.balance || 0;
}